import { c as _c } from "react/compiler-runtime";
import { Short, getAddressLink } from "@/components/short";
import { Popover, PopoverContent, PopoverTrigger } from "@defuse/ui/popover";
import { cn } from "@/lib/utils";
interface SendersProps {
  senders: string[];
  chain?: string | undefined;
  hashLength?: number;
  getLink?: ((sender: string) => string | undefined) | undefined;
  onInternalLinkClick?: (() => void) | undefined;
  scroll?: boolean;
  className?: string;
  compact?: boolean;
}
export function Senders(t0) {
  const $ = _c(25);
  const {
    senders,
    chain,
    hashLength,
    getLink,
    onInternalLinkClick,
    scroll: t1,
    className,
    compact: t2
  } = t0;
  const scroll = t1 === undefined ? true : t1;
  const compact = t2 === undefined ? false : t2;
  if (senders.length === 0) {
    return null;
  }
  let t3;
  let t4;
  if ($[0] !== chain || $[1] !== className || $[2] !== compact || $[3] !== getLink || $[4] !== hashLength || $[5] !== onInternalLinkClick || $[6] !== scroll || $[7] !== senders) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const [firstSender, ...restSenders] = senders;
      if (firstSender === undefined) {
        t4 = null;
        break bb0;
      }
      let t5;
      if ($[10] !== chain || $[11] !== getLink) {
        t5 = function getLinkFn(sender) {
          return getLink?.(sender) ?? getAddressLink(chain, sender);
        };
        $[10] = chain;
        $[11] = getLink;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      const getLinkFn = t5;
      let t6;
      if ($[13] !== className) {
        t6 = cn("text-muted-foreground flex flex-wrap items-center gap-x-1.5 text-sm", className);
        $[13] = className;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      let t7;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <span>Sender:</span>;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      let t8;
      if ($[16] !== firstSender || $[17] !== getLinkFn) {
        t8 = getLinkFn(firstSender);
        $[16] = firstSender;
        $[17] = getLinkFn;
        $[18] = t8;
      } else {
        t8 = $[18];
      }
      let t9;
      if ($[19] !== firstSender || $[20] !== hashLength || $[21] !== onInternalLinkClick || $[22] !== scroll || $[23] !== t8) {
        t9 = <Short text={firstSender} length={hashLength} link={t8} onInternalLinkClick={onInternalLinkClick} scroll={scroll} />;
        $[19] = firstSender;
        $[20] = hashLength;
        $[21] = onInternalLinkClick;
        $[22] = scroll;
        $[23] = t8;
        $[24] = t9;
      } else {
        t9 = $[24];
      }
      t3 = <div className={t6}>{t7}{t9}{restSenders.length > 0 && <Popover><PopoverTrigger asChild={true}><button type="button" className="hover:text-foreground relative cursor-pointer border-b border-dashed border-current pb-px leading-none transition-colors">+{restSenders.length}{!compact && " more"}</button></PopoverTrigger><PopoverContent className="w-auto p-3" align="start"><div className="text-muted-foreground flex flex-col gap-2 text-sm"><span className="text-xs font-medium">Other senders</span>{restSenders.map(sender_0 => <Short key={sender_0} text={sender_0} length={hashLength} link={getLinkFn(sender_0)} onInternalLinkClick={onInternalLinkClick} scroll={scroll} />)}</div></PopoverContent></Popover>}</div>;
    }
    $[0] = chain;
    $[1] = className;
    $[2] = compact;
    $[3] = getLink;
    $[4] = hashLength;
    $[5] = onInternalLinkClick;
    $[6] = scroll;
    $[7] = senders;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  return t3;
}